var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_935_109573)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_935_109573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_935_109573)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_935_109573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.566 59H32.4332C31.2576 59.0007 30.1305 59.469 29.2993 60.302C28.468 61.135 28.0007 62.2645 28 63.4426V143.557C28.0007 144.735 28.468 145.865 29.2993 146.698C30.1305 147.531 31.2576 147.999 32.4332 148H119.566C120.742 147.999 121.869 147.531 122.701 146.698C123.532 145.865 123.999 144.736 124 143.557V63.4426C123.999 62.2645 123.532 61.1348 122.701 60.3018C121.869 59.4688 120.742 59.0006 119.566 59Z",
    fill: "url(#paint2_linear_935_109573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4236 76.3956V75.4538C67.4479 71.0826 67.8611 67.605 68.6633 65.021C69.4898 62.4369 70.6566 60.36 72.1637 58.7903C73.6708 57.1964 75.5061 55.7353 77.6695 54.4071C79.1523 53.4894 80.4771 52.4871 81.6439 51.4004C82.835 50.2895 83.7709 49.0578 84.4515 47.7054C85.1321 46.3289 85.4725 44.7954 85.4725 43.1049C85.4725 41.197 85.0228 39.5427 84.1233 38.142C83.2239 36.7413 82.0085 35.6546 80.4771 34.8818C78.97 34.109 77.2806 33.7226 75.4088 33.7226C73.683 33.7226 72.0422 34.0969 70.4864 34.8456C68.955 35.5701 67.6788 36.681 66.6579 38.1783C65.6612 39.6514 65.1021 41.523 64.9806 43.7931H52C52.1215 39.2046 53.2397 35.3648 55.3545 32.2736C57.4937 29.1824 60.3134 26.864 63.8138 25.3184C67.3385 23.7728 71.2278 23 75.4818 23C80.1246 23 84.2084 23.809 87.7331 25.4271C91.2821 27.0451 94.0411 29.3514 96.0101 32.346C98.0034 35.3165 99 38.8424 99 42.9237C99 45.6768 98.5503 48.1401 97.6509 50.3136C96.7758 52.4871 95.5239 54.4191 93.8953 56.1096C92.2666 57.8001 90.3341 59.3095 88.0977 60.6378C86.1288 61.8453 84.5123 63.1011 83.2483 64.4052C82.0085 65.7092 81.0848 67.2428 80.4771 69.0057C79.8937 70.7445 79.5899 72.8939 79.5656 75.4538V76.3956H67.4236ZM73.768 99C71.5803 99 69.6964 98.2272 68.1164 96.6816C66.5363 95.136 65.7463 93.2523 65.7463 91.0305C65.7463 88.857 66.5363 86.9975 68.1164 85.4519C69.6964 83.9063 71.5803 83.1335 73.768 83.1335C75.9315 83.1335 77.8032 83.9063 79.3832 85.4519C80.9876 86.9975 81.7898 88.857 81.7898 91.0305C81.7898 92.5037 81.413 93.844 80.6594 95.0515C79.9302 96.259 78.9578 97.225 77.7424 97.9495C76.5513 98.6498 75.2265 99 73.768 99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.082 89.9508L68.5902 101.77H55.082V89.9508Z",
    fill: "url(#paint3_linear_935_109573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.955 100.425L123.814 144.186C123.507 146.374 121.646 148 119.451 148H31.7062C29.5113 148 27.6511 146.374 27.344 144.186L19.0441 85.0546C18.6697 82.3851 20.7277 80 23.4063 80H50.5038C52.6988 80 54.559 81.6259 54.866 83.8133L55.9537 91.557C56.2608 93.7448 58.121 95.3707 60.3159 95.3707H125.594C128.272 95.3707 130.33 97.7559 129.956 100.425H129.955Z",
    fill: "url(#paint4_linear_935_109573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.676 129H42.3239C41.9603 129 41.6091 128.875 41.3363 128.649C41.0634 128.422 40.8876 128.11 40.8418 127.77L40.0116 121.582C39.9852 121.384 40.0039 121.183 40.0663 120.993C40.1287 120.802 40.2335 120.626 40.3736 120.476C40.5138 120.327 40.6862 120.207 40.8793 120.125C41.0724 120.043 41.2819 120 41.4938 120H109.506C109.718 120 109.928 120.043 110.121 120.125C110.314 120.207 110.486 120.327 110.626 120.476C110.767 120.626 110.871 120.802 110.934 120.993C110.996 121.183 111.015 121.384 110.988 121.582L110.158 127.77C110.112 128.11 109.937 128.422 109.664 128.649C109.391 128.875 109.04 129 108.676 129Z",
    fill: "#C2EDFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_109573",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6CFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_935_109573",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_935_109573",
    x1: 76,
    y1: 59,
    x2: 76.2548,
    y2: 119.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_935_109573",
    x1: 64.0068,
    y1: 103.667,
    x2: 49.8468,
    y2: 87.4839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E78E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#3E78E7",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E78E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_935_109573",
    x1: 23.5492,
    y1: 118.135,
    x2: 130,
    y2: 118.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193638,
    stopColor: "#BED6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#C4DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72836,
    stopColor: "#BED6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#ABCAD8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.987c36e0622c8c182247affbfd9e3802.svg";
export { ForwardRef as ReactComponent };